module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00064-fs8.ab284b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00064-fs8.png
// module id = 217
// module chunks = 0